import { AsyncPipe, NgClass, NgIf } from "@angular/common";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { TranslocoModule } from "@ngneat/transloco";
import { Announcement, AnnouncementLevel } from "app/services/interfaces/announcement.interface";
import { NotificationBannerService } from "app/services/notification-banner.service";
import { Observable, Subject, takeUntil } from "rxjs";

@Component({
    selector: "notification-banner",
    standalone: true,
    imports: [NgIf, NgClass, AsyncPipe, MatIconModule, TranslocoModule],
    templateUrl: "./notification-banner.component.html",
    styleUrls: ["./notification-banner.component.scss"],
})
export class NotificationBannerComponent implements OnInit, OnDestroy {
    /**
     * Descarte efímero: oculta el aviso en la vista actual, pero al recargar el
     * componente se vuelve a montar y reaparece (requisito explícito).
     */
    dismissed = false;

    private _unsubscribeAll: Subject<void> = new Subject<void>();

    private readonly _levelClasses: Record<AnnouncementLevel, string> = {
        info: "notification-banner--info",
        success: "notification-banner--success",
        warning: "notification-banner--warning",
        danger: "notification-banner--danger",
    };

    private readonly _levelIcons: Record<AnnouncementLevel, string> = {
        info: "info",
        success: "check_circle",
        warning: "warning",
        danger: "error",
    };

    constructor(private _notificationBannerService: NotificationBannerService) {}

    get banner$(): Observable<Announcement | null> {
        return this._notificationBannerService.banner$;
    }

    ngOnInit(): void {
        this._notificationBannerService.fetchActive().pipe(takeUntil(this._unsubscribeAll)).subscribe();
    }

    levelClass(level: AnnouncementLevel): string {
        return this._levelClasses[level] ?? this._levelClasses.info;
    }

    levelIcon(level: AnnouncementLevel): string {
        return this._levelIcons[level] ?? "info";
    }

    onClose(): void {
        this.dismissed = true;
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
